<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card class="elevation-1">
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="handleModal">
          <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
        <v-toolbar-title>Generar reporte de pagos {{ clientName }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <SingleCalendar refElement="startDate" title="Fecha inicio" :input-date.sync="report.startDate" />
            <SingleCalendar refElement="endDate" title="Fecha fin" :input-date.sync="report.endDate" :min-date="report.startDate" />
          </v-col>
          <v-col cols="12" v-if="clientId == null">
            <v-autocomplete :items="clients" item-text="razonSocial" item-value="idCliente" v-model="report.clientId"
              label="Clientes" required outlined dense prepend-inner-icon="fas fa-user-alt"
              hint="Seleccione un cliente. Este campo es opcional" clearable>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="downloadExcelPago">
          <v-icon left>fas fa-file-excel</v-icon>Descargar Excel
        </v-btn>
           <v-btn color="blue darken-4" dark class="btn text-white" @click="previewPDF">
          <v-icon left>fas fa-file-pdf</v-icon>Ver PDF
        </v-btn>
      </v-card-actions>
    </v-card>
    <PreviewPDF :pdfSource="pdfSource" :pdfBlob="pdfBlob" title-pdf="PAGOS" :handlePdfModal="handlePdfModal"
      :dialog="showPdf" v-if="showPdf">
    </PreviewPDF>
  </v-dialog>
</template>
<script>
import PreviewPDF from '@/components/shared/PreviewPDF.vue';
import SingleCalendar from '@/components/shared/SingleCalendar.vue';
import { showErrorAlert, showInfoAlert } from '@/helpers/swalHelper';
import VentaPagoDataService from '@/service/venta/pago/VentaPagoDataService';
import { getDateLocaleNatural, getToday } from '@/utils/DateUtil';

export default {
  name: "ExcelExporterPago",
  props: {
    dialog: { type: Boolean, default: false },
    handleModal: { type: Function },
    client: { type: Object, required: false, default: () => { } },
    clients: { type: Array, required: false, default: () => [] },
  },
  created() {
    if (this.client) {
      this.report.clientId = this.client.idCliente;
      this.clientName = this.client.nombreComercial;
    }
  },
  components: { SingleCalendar, PreviewPDF },
  data() {
    return {
      clientName: '',
      report: {
        startDate: getToday().toFormat('yyyy-MM-dd'),
        endDate: getToday().toFormat('yyyy-MM-dd'),
        clientId: null
      },
      // TO pdf
      pdfBlob: '',
      pdfSource: null,
      showPdf: false
    }
  },
  methods: {
    downloadExcelPago() {
      const startDate = getDateLocaleNatural(this.report.startDate);
      const endDate = getDateLocaleNatural(this.report.endDate);
      VentaPagoDataService.downloadExcelPago({ startDate, endDate, clientId: this.report.clientId }).then(resp => {
        if (resp.status == 204) {
          this.$swal.fire({ icon: 'info', title: 'Reporte', text: 'No hay registros para descargar', showConfirmButton: false, timer: 1500 });
          return
        }
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement('a');
        link.href = url;
        if (startDate && endDate) {
          link.setAttribute('download', `Historial_de_pagos_${startDate} - ${endDate} - ${this.clientName}.xlsx`);
        } else {
          link.setAttribute('download', `Historial_de_pagos_${this.clientName}.xlsx`);
        }
        document.body.appendChild(link);
        link.click();
        link.remove();
      }).catch(err => {
        this.$swal.fire({ position: 'top-end', icon: 'error', html: 'Error al obtener los datos' + err.response.data, showConfirmButton: false, timer: 3500 });
      });
    },
    previewPDF(){
      const startDate = getDateLocaleNatural(this.report.startDate) ?? '';
      const endDate = getDateLocaleNatural(this.report.endDate) ?? '';
      const params = { startDate, endDate, clientId: this.report.clientId };
      VentaPagoDataService.printPdfPayments(params).then( response => {
        if(response.status == 204) {
          showInfoAlert({ title: 'Reporte PDF pagos', text: 'No hay registros para visualizar' });
          return
        }
        this.pdfBlob = new Blob([response.data], { type: 'application/pdf' })
        this.pdfSource = URL.createObjectURL(this.pdfBlob)
        this.showPdf = true
      }).catch( error => {
        showErrorAlert({ title: 'Error al generar el reporte', text: error?.response?.data });
      });
    },
    handlePdfModal(){
      this.showPdf = !this.showPdf
      this.cleanupPdf()
    },
    cleanupPdf(){
      if(this.pdfSource){
        URL.revokeObjectURL(this.pdfSource)
        this.pdfSource = null
      }
      this.pdfBlob = null
    }
  },
  watch: {
    'report.clientId': function () {
      this.clientName = this.clients.find(client => client.idCliente == this.report.clientId)?.nombreComercial ?? '';
    }
  },
  computed: {
    clientId() {
      return this.client === undefined ? null : this.client.idCliente;
    }
  }
}
</script>